import { InitializeAddSystemsRequestSchema, InitializeAddSystemsResponseSchema } from './initialize-add-systems.schema';
/**
 * Initialize Add Systems Contract
 * POST /api/v2/initialize/systems
 * Bulk create systems with an email-resolved Systemverantwortliche:r.
 */ export const InitializeAddSystemsContract = {
    method: 'POST',
    path: '/api/v2/initialize/systems',
    description: 'Bulk create systems during initial setup',
    requestSchema: InitializeAddSystemsRequestSchema,
    responseSchema: InitializeAddSystemsResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Invalid request body, unresolved emails, or prerequisites missing',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - insufficient permissions'
        }
    }
};

//# sourceMappingURL=initialize-add-systems.contract.js.map